angular.module('unergie.main')
.filter('contractPlan', () =>
    function (val) {
        if (val === 10) { return 'BASE' } return 'HP/HC'
    },
)
